import React, { useState } from "react";
import { motion } from "framer-motion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../features/movimentiSlice";
import { setInfo, setLoggedOut } from "../../features/userSlice";
import { setSaldoGraphData } from "../../features/saldoGraphDataSlice";
import { setDataBox } from "../../features/dataBoxHomeSlice";
import Conferma from "../Conferma/Conferma";

const pagesEnergia = [
  { name: "Home", url: "/enrica" },
  { name: "Ricarica 3-6-12", url: "/enrica/promo" },
  { name: "Consumi", url: "/enrica/consumi" },
  { name: "Movimenti", url: "/enrica/movimenti" },
  { name: "Fatture", url: "/enrica/fatture" },
  { name: "Letture", url: "/enrica/letture" },
  // { name: "Altri oneri", url: "/enrica/altri-oneri"},
  { name: "Fai da te", url: "/enrica/fai-da-te" },
  { name: "Esci", url: "/enrica" },
];
const pagesGas = [
  { name: "Home", url: "/enrica/gas" },
  { name: "Consumi", url: "/enrica/gas/consumi" },
  { name: "Movimenti", url: "/enrica/gas/movimenti" },
  { name: "Fatture", url: "/enrica/gas/fatture" },
  { name: "Letture", url: "/enrica/gas/letture" },
  { name: "Esci", url: "/enrica" },
];
const variantsUl = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};
const variantsLi = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

function ListNav({ seeMenu, setSeeMenu }) {
  const dispatch = useDispatch();
  const section = useSelector((user) => user.settings.section);
  const location = useLocation();
   const [seeConferma, setSeeConferma] = useState(false)
  const logOut = () => {
    navigate("/enrica");
    localStorage.clear();
    dispatch(setData(null));
    dispatch(setLoggedOut());
    dispatch(setSaldoGraphData(null));
    dispatch(setDataBox(null));
    dispatch(setInfo(null));
  };
  let navigate = useNavigate();

  const handleNav = (to) => {
    if (to.name === "Esci") {
      setSeeConferma(true);
    } else {
      location.pathname === to.url ? setSeeMenu(false) : navigate(to.url);
    }
  };
  return (
    <div className="listaNav">
      {seeConferma && <Conferma setSeeConferma={setSeeConferma} mainFunction={logOut} />}
      <motion.ul variants={variantsUl}>
        {section
          ? pagesGas.map((page, i) => (
              <motion.li
                key={i}
                variants={variantsLi}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleNav(page)}
              >
                <p>
                  {page.name} <ArrowForwardIosIcon />
                </p>
              </motion.li>
            ))
          : pagesEnergia.map((page, i) => (
              <motion.li
                key={i}
                variants={variantsLi}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleNav(page)}
              >
                <p>
                  {page.name} <ArrowForwardIosIcon />
                </p>
              </motion.li>
            ))}
      </motion.ul>
    </div>
  );
}

export default ListNav;
